module.exports = __webpack_public_path__ + "static/CNY25_MFKV-d0409162c9f1f21f00b0aeb8012d2ff0.webp";